import { forwardRef } from 'react'
import { cn } from '@global/utils/tailwind'

interface BottomSheetProps {
  children: React.ReactNode
  className?: string
}

export const BottomSheet = forwardRef<HTMLDivElement, BottomSheetProps>(
  ({ children, className }, ref) => {
    return (
      <div
        ref={ref as React.Ref<HTMLDivElement>}
        className={cn(
          'z-[170] absolute right-0 text-black bg-white border border-gray-300 rounded-lg shadow-lg p-4 mt-2',
          className,
        )}
      >
        {children}
      </div>
    )
  },
)

BottomSheet.displayName = 'BottomSheet'
